// Photo EXCEPTION of the copycat study: the reference gym photos of Appetite UI are not licensed for reuse, so the study uses
// four of the five ACS photos already authorised and copied byte for byte in ../assets/photos (provenance in COMPONENTS.md).
// No stock or reference photo is downloaded. URLs resolve against the bundle (dist/assets) through import.meta.url.
import avatarSrc from "../assets/photos/acs-3009-01-10c964d8-d72d-4ff4-9fb0-a85edd856f1e.webp";
import featuredSrc from "../assets/photos/acs-3009-26-img_9870.webp";
import squatSrc from "../assets/photos/acs-3009-17-img_4225.webp";
import rowSrc from "../assets/photos/acs-3009-14-img_4020.webp";
import groupSrc from "../assets/photos/acs-3009-16-img_4094.webp";

const url = (file: string) => new URL(file, import.meta.url).href;

export const PHOTOS = {
  avatar: url(avatarSrc),
  featured: url(featuredSrc),
  upNext: url(squatSrc),
  exercise: url(squatSrc),
  deadlift: url(rowSrc),
  second: url(groupSrc),
} as const;
